import React from 'react';
import { Typography, Box, Button } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import StopperComponent from '../components/Stopper/StopperDeveloper';
import IntroBox from '../components/Intro/IntroBox';
import { useNavigate } from 'react-router-dom';
import { incrementStep } from '../Slice/unifiedFormSlice';

const MODES = {
  START: 'start',
  NEW: 'new',
  END: 'end',
};

const Intro: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const currentStep = useSelector(
    (state: RootState) => state.unifiedForm.currentStep,
  );

  const handleGoToIdentify = () => {
    dispatch(incrementStep()); // افزایش currentStep به 3
    navigate('/identify', { state: { idedntty: 'personal', mode: 'start' } });
  };

  console.log('Current Step intro:', currentStep);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Typography variant="body1" sx={{ paddingBottom: 4 }}>
        <StopperComponent activeStep={currentStep} />
      </Typography>
      <Typography variant="body1">
        <IntroBox mode={MODES.START} />
      </Typography>
    </Box>
  );
};

export default Intro;
